import { ref, computed } from 'vue';
import i18n from '@/i18n';
import { helpers, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

export const useMixins = (payload) => {
  const fileUploadEn = ref();
  const fileUploadFr = ref();
  const currentLanguage = i18n.global.locale.value;
  const rules = ref({});
  const notRequired = ['sk', 'order'];
  Object.entries(payload)
    .filter(([property]) => !notRequired.includes(property))
    .forEach(([property]) => {
      rules.value[property] = {
        required: helpers.withMessage(i18n.global.t('validate.required'), required)
      };
    });
  const v$ = useVuelidate(rules, payload);

  const previewEn = computed(() => {
    const { titleEn, subTitleEn, descEn, imgUrlEn, imgTitleEn, termsEn, nameFirstButtonEn, urlSecondButtonEn, nameSecondButtonEn, urlFirstButtonEn, colorEn, showInB2bEn, imageEn } = payload;

    const nameSubTitle = subTitleEn || '';
    const term = termsEn || '';
    const nameFirstButton = nameFirstButtonEn || '';
    const urlFirstButton = urlFirstButtonEn || '';
    const nameSecondButton = nameSecondButtonEn || '';
    const urlSecondButton = urlSecondButtonEn || '';

    return {
      name: titleEn,
      subTitle: nameSubTitle,
      description: descEn,
      image: imgUrlEn,
      isShow: showInB2bEn,
      imageTitle: imgTitleEn,
      color: colorEn,
      term,
      nameFirstButton,
      urlFirstButton,
      nameSecondButton,
      urlSecondButton,
      renderImage: imageEn
    };
  });

  const previewFr = computed(() => {
    const { titleFr, subTitleFr, descFr, imgUrlFr, imgTitleFr, termsFr, nameFirstButtonFr, urlSecondButtonFr, nameSecondButtonFr, urlFirstButtonFr, colorFr, showInB2bFr, imageFr } = payload;

    const nameSubTitle = subTitleFr || '';
    const term = termsFr || '';
    const nameFirstButton = nameFirstButtonFr || '';
    const urlFirstButton = urlFirstButtonFr || '';
    const nameSecondButton = nameSecondButtonFr || '';
    const urlSecondButton = urlSecondButtonFr || '';

    return {
      name: titleFr,
      subTitle: nameSubTitle,
      description: descFr,
      isShow: showInB2bFr,
      image: imgUrlFr,
      imageTitle: imgTitleFr,
      term,
      color: colorFr,
      nameFirstButton,
      urlFirstButton,
      nameSecondButton,
      urlSecondButton,
      renderImage: imageFr
    };
  });

  const handleRemoveFile = (lang) => {
    const updateValues = {
      english: () => {
        fileUploadEn.value.uploadedFileCount = 0;
        payload.imgUrlEn = '';
      },
      french: () => {
        fileUploadFr.value.uploadedFileCount = 0;
        payload.imgUrlFr = '';
      }
    };

    updateValues[lang]?.();
  };
  const onAdvancedUpload = (res, lang) => {
    let urlImg = '';
    if (res.xhr.status === 200) {
      urlImg = res.xhr.response;
    }
    const langMapping = {
      english: 'imgUrlEn',
      french: 'imgUrlFr'
    };
    payload[langMapping[lang]] = urlImg;
  };

  return { currentLanguage, v$, previewEn, previewFr, fileUploadEn, fileUploadFr, handleRemoveFile, onAdvancedUpload };
};
